import React from 'react';
import { CoreButton, CoreInputBox } from 'whealth-core-web/components';
import { useGetLoginUserDataQuery } from 'redux/apiSlice';

function SettingsForm(props) {
  const { placeholder, value, error, isUpdate, setValue, label, required, onClick } = props;
  const userData = useGetLoginUserDataQuery()?.data?.data || {};
  return (
    <div>
      <CoreInputBox
        showMSG={error}
        placeholder={placeholder}
        value={value}
        label={label}
        setValue={setValue}
        retuired
        msgStyle={{ color: 'red' }}
        maxLength={255}
      />
      {!userData?.read_only && <CoreButton onClick={onClick} title={isUpdate ? 'Update' : 'Save'} />}
    </div>
  );
}

export default SettingsForm;
